<template>
  <router-view />
</template>

<script setup lang="ts">
defineOptions({
  name: 'BlankLayout'
})
</script>

<style scoped></style> 